import { Button } from "@silversea-ssc/ui-components-react";
import React, { PropsWithChildren, useCallback } from "react";
import * as styles from "./CruiseDrawerExpandableSection.module.scss";

type Props = {
  label: string;
  dataContentName: string;
};

const CruiseDrawerExpandableSection: React.FC<PropsWithChildren<Props>> = ({
  label,
  dataContentName,
  children
}) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [isExpanded, setIsExpanded] = React.useState(false);

  const toggleExpanded = useCallback(() => {
    setIsExpanded((prev) => {
      if (prev == false) {
        scrollIntoExpandableSection(ref.current);
      }
      return !prev;
    });
  }, []);

  return (
    <>
      <Button
        renderAs="button"
        onClick={toggleExpanded}
        variant="inline-text"
        dataContentPiece={
          isExpanded
            ? `expand-${dataContentName}`
            : `collapse-${dataContentName}`
        }
        iconName={isExpanded ? "chevron-up" : "chevron-down"}
        className={styles.button}
      >
        {label}
      </Button>
      <div ref={ref} className={styles.scollable}>
        {isExpanded && <>{children}</>}
      </div>
    </>
  );
};
export default CruiseDrawerExpandableSection;

const scrollIntoExpandableSection = (element: HTMLDivElement | null) => {
  setTimeout(() => {
    if (element) {
      element.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, 100);
};
